<template>
    <div>
        <legend>{{$t('Interval')}}</legend>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-6">
                <fg-input :label="$t('Time')" name="time" required
                          v-model="time">
                    <el-time-select
                            v-model="time"
                            :picker-options="{start: '00:00', step: '1:00', end: '23:59'}"
                            required
                            :placeholder="$t('Select time')">
                    </el-time-select>
                </fg-input>

                <label>{{$t('Repeat every')}}</label>
                <div class="row">
                    <div class="col-6">
                        <el-input-number v-model="value.repeatEvery.count" controls-position="right" :min="1"/>
                    </div>
                    <div class="col-6">
                        <fg-input name="repeatEvery.type" v-model="value.repeatEvery.type" :error="getError('repeatEvery.type')">
                            <el-select class="select-primary"
                                       size="large"
                                       name="repeatEvery.type"
                                       v-model="value.repeatEvery.type"
                                       v-validate="{required: !value.repeatEvery.type}"
                                       :placeholder="`${$t('Select')}...`">
                                <el-option v-for="option in options('repeatEvery')"
                                           :value="option.value"
                                           :label="option.title"
                                           :key="option.value">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>

                <div v-if="value.repeatEvery.type">
                    <label>{{$t('Repeat at')}}</label>
                    <div class="row">
                        <div v-if="value.repeatEvery.type === 'month'" class="col-6">
                            <el-input-number v-model="value.repeatAt.count" controls-position="right" :min="1"/>
                        </div>
                        <div class="col-6">
                            <fg-input name="repeatEvery.type" v-model="value.repeatAt.type">
                                <el-select class="select-primary"
                                           size="large"
                                           name="repeatAt.type"
                                           multiple
                                           filterable
                                           default-first-option
                                           v-model="value.repeatAt.type">
                                    <el-option v-for="option in options('repeatAt')"
                                               :value="option.value"
                                               :label="option.title"
                                               :key="option.value">
                                    </el-option>
                                </el-select>
                            </fg-input>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <slot name="body"/>
            </div>
        </div>
    </div>
</template>

<script>
  import { Input, Button, Select, Option, Checkbox, TimeSelect, InputNumber } from 'element-ui'
  import moment from 'moment'
  import concat from 'lodash/concat'

  export default {
    name: 'BasicTimingPicker',

    components: {
      [Input.name]: Input,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Option.name]: Option,
      [Select.name]: Select,
      [TimeSelect.name]: TimeSelect,
      [InputNumber.name]: InputNumber
    },

    inject: ['$validator'],

    props: {
      value: {
        type: Object
      }
    },

    mounted () {
      let time = this.value.time
      if (!time || time === '') {
        this.time = '08:00'
      } else {
        this.time = moment(this.value.time).format('HH:mm')
      }
    },

    methods: {
      options: function (type) {
        switch (type) {
          case 'repeatEvery':
            return [{ title: this.$t('Week'), value: 'week' }, { title: this.$t('Month'), value: 'month' }]
          case 'repeatAt':
            const weekdays = moment.weekdays().map((weekday, i) => ({ title: weekday, value: i.toString() }))
            if (this.value.repeatEvery.type === 'week') {
              return weekdays
            } else {
              return concat([{ title: this.$t('Working day'), value: 'weekday' }], weekdays)
            }
          default:
            return []
        }
      },
      getError (fieldName) {
        const error = this.errors.first(fieldName)
        if (error) {
          return this.$t('Please select an option')
        }
      }
    },
    data () {
      return {
        time: ''
      }
    },
    watch: {
      'time' (val) {
        let newValue = this.value
        if (val || val !== '') {
          let newValue = this.value
          newValue.time = moment(val, "HH:mm").toISOString()
          this.$emit('input', newValue)
        } else {
          newValue.time = val
          this.$emit('input', newValue)
        }
      },
      'value.repeatEvery.type' (val) {
        if (val) {
          let newValue = this.value
          if (val === 'week') {
            newValue.repeatAt.type = ['1']
          } else if (val === 'month') {
            newValue.repeatAt.type = ['weekday']
          }
          this.$emit('input', newValue)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
    .el-input-number.is-controls-right {
        width: 100%;
        min-width: 70px;

        .el-input-number__increase {
            width: 30px;
        }

        .el-input-number__decrease {
            width: 30px;
        }
    }
</style>